import { v4 as uuidv4 } from 'uuid'

export function getNewId(): string {
  return uuidv4()
}
